import styled from 'styled-components';
import TableCell from '../table/TableCell';
export const ReferralProgramContainer = styled.div `
  width: 100%;
  padding: 1.6rem;

  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  box-shadow: ${({ theme }) => theme.shadows.lg};

  ${({ theme }) => theme.media.laptop `
      padding: 0.8rem 0.8rem 2.4rem;
  `}
`;
export const ReferralProgramTitleWrapper = styled.div `
  width: 100%;
  padding: 1.2rem 0;
  margin-bottom: 1.6rem;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.high};
`;
export const AssetImg = styled.img `
  height: 6.4rem;
`;
export const ProgramDescWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  align-items: start;
  ${({ theme }) => theme.media.tabletL `
      max-width: 80%;
  `}
`;
export const AssetWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.4rem;
`;
export const CustomTableCell = styled(TableCell) `
  .cellDescription {
    align-items: end;
    flex-direction: row;
    gap: 0.8rem;
  }

  ${({ theme }) => theme.media.tablet `
   .secondaryDesc {
      padding-bottom: 0.4rem;
    }
  `}
`;
export const StepWrapper = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;

  padding: 1.2rem 1.8rem 1.2rem 3.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background-color: ${({ theme }) => theme.colors.text.interactive};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;
export const StepIndex = styled.div `
  height: 4rem;
  width: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  left: -2rem;

  background: linear-gradient(144.31deg, #3d62d7 -16.06%, #191c7a 121.84%);
  border-radius: ${({ theme }) => theme.borderRadius.highest};
`;
export const ContentWrapper = styled.div `
  padding: 0 0.8rem;
`;
//# sourceMappingURL=styles.js.map